import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ProductApiService } from 'src/app/services/api/product-api.service';

@Component({
  selector: 'app-platform-label',
  templateUrl: './platform-label.component.html',
  styleUrls: ['./platform-label.component.scss'],
})
export class PlatformLabelComponent implements OnChanges {
  @Input() id = 0;
  constructor(private api: ProductApiService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.getPlatform();
  }

  data: any;
  async getPlatform() {
    if (!this.id) {
      this.data = null;
      return;
    }
    try {
      const r = await this.api.getPlatform(this.id);
      this.data = r.data;
    } catch (error) {}
  }
}
